module.exports = __webpack_public_path__ + "img/Flag_of_Peru.23f4fbf5.svg";